import React from 'react';
import styled from 'styled-components';

const FlagSvg = styled.svg`
  width: 100%;
  height: 100%;
`;

const CanadaFlag = () => {
  return (
    <FlagSvg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="50" height="25" viewBox="0 0 50 25">
      <defs>
        <rect id="a" width="50" height="25" rx="4"/>
        <rect id="c" width="50" height="25" rx="4"/>
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a"/>
        </mask>
        <use fill="#FFF" xlinkHref="#a"/>
        <g fillRule="nonzero" mask="url(#b)">
          <path fill="#F00" d="M0 0h50v25H0z"/>
          <path fill="#FFF" d="M12.5 0h25v25h-25z"/>
          <path fill="#F00" d="M25 2.344l-1.706 3.181c-.194.346-.54.314-.887.12l-1.235-.639.92 4.887c.194.892-.427.892-.734.506l-2.155-2.412-.35 1.225c-.04.16-.217.33-.483.29l-2.725-.573.715 2.602c.154.579.273.819-.154.971l-.972.457 4.691 3.81c.186.144.28.404.214.638l-.41 1.348c1.614-.187 3.062-.467 4.678-.64.142-.014.381.221.38.386l-.214 4.936h.786l-.124-4.925c-.001-.165.216-.411.358-.396 1.616.172 3.064.452 4.679.639l-.41-1.348a.614.614 0 0 1 .213-.638l4.69-3.81-.97-.457c-.428-.152-.309-.392-.155-.971l.715-2.602-2.725.572c-.266.04-.443-.128-.484-.29l-.35-1.224-2.154 2.412c-.307.386-.928.386-.734-.506l.92-4.887-1.235.64c-.347.193-.693.225-.887-.121"/>
        </g>
        <rect width="49" height="24" x=".5" y=".5" stroke="#F00" rx="4"/>
      </g>
    </FlagSvg>
  );
};

export default CanadaFlag;
